import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const faqData = [
  {
    question: "What is a SARASU NEET Online Testing Practice?",
    answer:
      "Sarasu NEET Online testing practice software simplifies the NEET MCQ testing and evaluation process for teachers. It also provides customized subject-wise testing practice.",
  },
  {
    question: "What difference does SARASU make in teaching institutes?",
    answer:
      "SARASU provides immediate results, capability analysis reports, chapter-wise performance tracking, speed analysis, and graphical insights that help institutions identify student weaknesses and improve performance.",
  },
  {
    question: "Can the testing practice & evaluation be customized?",
    answer:
      "Teachers receive admin access where they can assign unlimited NEET MCQ tests based on completed chapters and create customized mock tests.",
  },
  {
    question:
      "What is the cost of SARASU Institute NEET Testing Practice Software?",
    answer:
      "SARASU is available at ₹800 per student per month, making it an affordable solution for continuous NEET preparation and performance analysis.",
  },
  {
    question:
      "Is SARASU ideal for NEET competitive exam teaching institutes?",
    answer:
      "Yes. SARASU includes Speed Trainer, Test Marathon, Biology Champion League, and unlimited customized practice tests to improve student speed and accuracy.",
  },
];

export default function Gallery() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      className="py-5"
      style={{
        background: "#f8fafc",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="badge px-3 py-2 mb-3"
            style={{
              background: "#e0f2fe",
              color: "#0369a1",
              fontSize: "0.9rem",
            }}
          >
            Frequently Asked Questions
          </span>

          <h2
            className="fw-bold"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              color: "#0f172a",
            }}
          >
            Everything You Need To Know
          </h2>

          <p
            className="text-muted mx-auto"
            style={{
              maxWidth: "700px",
            }}
          >
            Learn more about SARASU NEET Testing Platform and how it helps
            institutions improve student performance.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="card border-0 shadow-sm mb-3 overflow-hidden"
                style={{
                  borderRadius: "18px",
                }}
              >
                <button
                  className="btn text-start p-4 d-flex justify-content-between align-items-center"
                  onClick={() => toggleFAQ(index)}
                >
                  <span
                    className="fw-semibold"
                    style={{
                      color: "#0f172a",
                      fontSize: "1rem",
                    }}
                  >
                    {item.question}
                  </span>

                  <span
                    style={{
                      color: "#16a34a",
                    }}
                  >
                    {activeIndex === index ? (
                      <FaMinus />
                    ) : (
                      <FaPlus />
                    )}
                  </span>
                </button>

                <div
                  style={{
                    maxHeight:
                      activeIndex === index ? "300px" : "0px",
                    overflow: "hidden",
                    transition: "all 0.35s ease",
                  }}
                >
                  <div
                    className="px-4 pb-4"
                    style={{
                      color: "#64748b",
                      lineHeight: "1.8",
                    }}
                  >
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}